/*
 * @Autor: hansong27
 * @Email: hansong27@jd.com
 * @Description:
 * @CreateDate: Do not edit
 * @LastEditors: hansong27
 */
import { FC, useState, useEffect } from "react";
import { switchTenant, tenantListTree } from "@/api/tenant";
import "./index.less";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

const Tenant: FC = () => {
    const [tenantList, setTenantList] = useState([]);
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        tenantListTree()
            .then((res: any) => {
                setTenantList(res.data || []);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const chooseTenant = (tenantItem: any) => {
        const { tenantCode } = tenantItem;
        switchTenant({ tenantCode })
            .then((res: any) => {
                dispatch({
                    type: "setFirstTenant",
                    value: tenantItem,
                });
                history.replace("/");
            })
            .catch((err: any) => {
                console.error("err: ", err);
            });
    };

    return (
        <div className="oneorg-box">
            <div className="oneorg-content">
                <div className="oneorg-text">
                    <img
                        src="https://img10.360buyimg.com/imagetools/jfs/t1/210550/26/18877/8531/62281626Eac8d8eff/195a383ab09729f1.png"
                        alt=""
                    />
                </div>
                <div className="oneorg-select">
                    {tenantList.map((tenantItem: any) => (
                        <div
                            className="select-item"
                            key={tenantItem.tenantCode}
                            onClick={() => chooseTenant(tenantItem)}
                        >
                            <div className="select-text">
                                <img
                                    src="https://img12.360buyimg.com/imagetools/jfs/t1/171168/36/29269/3697/63047c89E0c265571/4b9e7e984988ef59.png"
                                    alt=""
                                />
                                <span>{tenantItem.orgName}</span>
                            </div>
                            <div className="select-img">
                                <img
                                    src="https://img12.360buyimg.com/imagetools/jfs/t1/112083/34/22911/567/622814e4Ea95b1943/75d85a0110afd835.png"
                                    alt=""
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Tenant;
